module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepOne.svg?c6e41b4b";